import { emptyTurnContext, type CompanySkill, type WorkspaceTurnContext } from './types';

// The wire contract bounds explicit attachments separately from saved Skill references.
export const WORKSPACE_ATTACHMENT_LIMIT = 30;

export function selectedSkillSnapshot(context: WorkspaceTurnContext, skill?: CompanySkill) {
  if (!skill || skill.id !== context.intent.skillId) return null;
  const snapshot = context.intent.mode === 'skill-run' ? skill.published : skill.draft;
  return snapshot?.revision === context.intent.revision ? snapshot : null;
}

/** Selecting a Skill never copies its saved references into conversation attachments. */
export function skillContext(
  skill: CompanySkill,
  mode: 'skill-author' | 'skill-preview' | 'skill-run',
  attachments = emptyTurnContext(),
): WorkspaceTurnContext {
  return {
    ...attachments,
    intent: {
      mode,
      skillId: skill.id,
      revision: mode === 'skill-run' ? skill.published!.revision : skill.currentRevision,
    },
    selection: undefined,
  };
}

export function fileAttachmentStatus(
  context: WorkspaceTurnContext,
  skill: CompanySkill | undefined,
  id: string,
) {
  if (context.fileIds.includes(id)) return 'attached';
  if (context.fileIds.length >= WORKSPACE_ATTACHMENT_LIMIT) return 'full';
  if (selectedSkillSnapshot(context, skill)?.fileIds.includes(id)) return 'saved';
  return 'available';
}
